<template>
  <div class="design-rirekisho-001-preview-doc">
    <!--デザイン履歴書1枚目-->
    <div id="preview-page-01" class="d-doc-paper preview rirekisho">
      <div class="flex">
        <div class="d-rirekisho-box1">
          <div data-highlight="クリックで編集" class="rirekisho-profile d-left">
            <!--基本情報-->
            <div class="basic-info">
              <div
                class="id-photo"
                :data-highlight="highlightMessage"
                @click="goCardTo('id-photo')"
                :class="highLightClass('id-photo')"
              >
                <img
                  v-if="basicData.idPhotoSrc"
                  :src="basicData.idPhotoSrc"
                  alt="証明写真"
                />
                <img
                  v-else
                  src="https://placehold.jp/150x150.png"
                  alt="証明写真"
                />
              </div>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('design-profile')"
                :class="highLightClass('profile')"
                class="d-name"
              >
                <div :style="formatData.selFontStyle">
                  {{ basicData.lastName }}&emsp;{{ basicData.firstName }}
                </div>
              </div>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('design-profile')"
                :class="highLightClass('profile')"
                class="d-ruby"
              >
                <div :style="formatData.selFontStyle">
                  {{ basicData.lastNameFurigana }}&emsp;{{
                    basicData.firstNameFurigana
                  }}
                </div>
              </div>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('design-profile')"
                :class="highLightClass('profile')"
                class="d-birthday"
              >
                <div>
                  （<span>{{ basicData.birthYear }}</span
                  >年）
                </div>
              </div>
              <div class="d-occupation">
                <div :style="formatData.selFontStyle">
                  {{ formatData.job_category }}
                </div>
              </div>
            </div>
            <!--連絡先-->
            <div class="d-contact">
              <h2 class="d-h2">連絡先<span>CONTACT</span></h2>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('contacts')"
                :class="highLightClass('contacts')"
                class="d-tel"
              >
                <div class="label">電話番号</div>
                <div class="input" :style="formatData.selFontStyle">
                  {{ tel }}
                </div>
              </div>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('contacts')"
                :class="highLightClass('contacts')"
                class="d-mail"
              >
                <div class="label">メールアドレス</div>
                <div class="input" :style="formatData.selFontStyle">
                  {{ basicData.email }}
                </div>
              </div>
              <div
                :data-highlight="highlightMessage"
                @click="goCardTo('address')"
                :class="highLightClass('address')"
                class="d-address"
              >
                <div class="label">住所</div>
                <div class="input" :style="formatData.selFontStyle">
                  &#12306;{{
                    formLib.separatedPostNumber(basicData.postNumber)
                  }}
                  {{ basicData.address1 }} {{ basicData.address2 }}
                </div>
              </div>
            </div>
            <!--趣味-->
            <div
              :data-highlight="highlightMessage"
              @click="goCardTo('hobby')"
              :class="highLightClass('hobby')"
              class="d-hobby"
            >
              <h2 class="d-h2">趣味<span>HOBBY</span></h2>
              <div class="hobby-list">
                <ul class="flex">
                  <li
                    v-for="(val, idx) in formatData.hobbies"
                    :key="idx"
                    class="hobby-item"
                    style="line-height: 1.2; width: calc(100% / 3)"
                  >
                    <img
                      :src="hobbyOptions[val.id]?.image"
                      style="line-height: 1.2"
                    /><span>{{ val.name }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div
          @click="goCardTo('edu-history')"
          :class="highLightClass(['edu-history'])"
          class="d-right"
        >
          <div class="d-education">
            <h2 class="d-h2" style="text-align: center">
              学歴<span>EDUCATION</span>
            </h2>
            <div class="education-timeline">
              <ul>
                <li
                  v-for="(item, index) in formatData.educationalHistories"
                  :key="index"
                  class="m-bottom"
                >
                  <ul class="flex m-bottom" v-if="true">
                    <li class="education-year" :style="formatData.selFontStyle">
                      {{ item.year }}.{{ item.month }}
                    </li>
                    <li
                      class="education-status"
                      :style="formatData.selFontStyle"
                    >
                      {{ item.description }}
                    </li>
                  </ul>
                  <ul class="flex m-bottom" v-else>
                    <li class="education-year" :style="formatData.selFontStyle">
                      {{ item.description }}
                    </li>
                    <li
                      class="education-status"
                      :style="formatData.selFontStyle"
                    >
                      {{ item.year }}.{{ item.month }}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-skill">
            <h2 class="d-h2" style="text-align: center">
              スキル<span>SKILL</span>
            </h2>
            <div class="skill-list">
              <ul>
                <li v-for="(item, index) in formatData.skills" :key="index">
                  <ul class="flex flex-center m-bottom skill-flex">
                    <li class="skill-kinds" :style="formatData.selFontStyle">
                      {{ item.description }}
                    </li>
                    <li>
                      <span
                        v-for="n in item.skill_level"
                        :key="'skill-full-' + n"
                        class="skill-full"
                        >★</span
                      >
                      <span
                        v-for="n in 5 - item.skill_level"
                        :key="'skill-empty-' + n"
                        class="skill-full"
                        >☆</span
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div class="d-license">
            <h2 class="d-h2" style="text-align: center">
              資格<span>LICENSE</span>
            </h2>
            <div class="license-list">
              <ul>
                <li
                  v-for="(item, index) in formatData.licenseHistories"
                  :key="index"
                >
                  <ul class="flex m-bottom">
                    <li class="license-year" :style="formatData.selFontStyle">
                      {{ item.year }}.{{ item.month }}
                    </li>
                    <li class="license-kinds" :style="formatData.selFontStyle">
                      {{ item.description }}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="d-pr"
            @click="goCardTo('mypr')"
            :class="highLightClass(['mypr'])"
          >
            <h2 class="d-h2" style="text-align: center">
              自己紹介<span>PR</span>
            </h2>
            <div class="pr-block">
              <div class="input">
                <pre
                  ref="mypr"
                  :class="classObject.mypr"
                  :style="formatData.selFontStyle"
                  style="
                    white-space: pre-wrap;
                    line-height: 1.8;
                    font-size: 14px;
                  "
                  >{{ formatData.mypr }}</pre>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--デザイン履歴書2枚目-->
    <div
      id="preview-page-02"
      class="d-doc-paper preview rirekisho"
      style="break-before: page"
    >
      <div
        class="d-career m-bottom"
        @click="goCardTo('job-history')"
        :class="highLightClass(['job-history'])"
      >
        <h2 class="d-h2" style="text-align: center">職歴<span>CAREER</span></h2>
        <div class="career-timeline">
          <ul>
            <li
              v-for="(item, index) in formatData.jobDetailHistories"
              :key="index"
            >
              <ul class="flex m-bottom">
                <li class="career-year">
                  <span class="d-small"
                    >{{ item.startYear }}.{{ item.startMonth }}-</span
                  >{{ item.endYear }}.{{ item.endMonth }}
                </li>
                <li class="career-status">{{ item.companyName }}</li>
              </ul>
              <ul
                v-for="(sub_item, sub_index) in item.projects"
                :key="sub_index"
                class="flex sub-career m-bottom"
              >
                <li class="career-year">
                  <span
                    >{{ sub_item.startYear }}.{{ sub_item.startMonth }}-</span
                  >{{ sub_item.endYear }}.{{ sub_item.endMonth }}
                </li>
                <li class="career-status">{{ sub_item.projectTitle }}</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div
        class="d-motivation"
        @click="goCardTo('reason')"
        :class="highLightClass(['reason'])"
        v-if="false"
      >
        <h2 class="d-h2" style="text-align: center">
          志望動機<span>MOTIVATION</span>
        </h2>
        <div class="motivation-block">
          <div class="input">
            <pre
              ref="reason"
              :class="classObject.reason"
              style="white-space: pre-wrap; line-height: 1.8; font-size: 14px"
              :style="formatData.selFontStyle"
              >{{ formatData.reason }}</pre>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}

const props = withDefaults(defineProps<FormatPreviewSfcProps>(), {
  previewScale: 1,
  currentCardId: '',
  idPrefix: '',
  isSample: false
})

const {
  reason,
  mypr,
  checkValid,
  formLib,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  tel
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { reason: 180, request: 180, mypr: 180 },
  overflowFields: ['reason', 'reasonNew', 'request', 'addressFurigana', 'mypr'],
  revalidateOnFormatDataChange: true
})

defineExpose({ checkValid })
</script>

<style
  lang="scss"
  scoped
  src="@/assets/scss/format-edit/design-rirekisho-001-preview.scss"
></style>
